// ============================================
// 📞 Show a phone number the way people read it: +91 98100 88212
// For DISPLAY only — links, forms and messages keep the raw number.
// ============================================
export function formatPhone(raw) {
  if (raw === null || raw === undefined) return '';
  const s = String(raw).trim();
  const d = s.replace(/\D/g, '');
  if (!d) return s;
  let ten = null;
  if (d.length === 12 && d.startsWith('91')) ten = d.slice(2);
  else if (d.length === 10 && /^[6-9]/.test(d)) ten = d;
  else if (d.length === 11 && d.startsWith('0') && /^[6-9]/.test(d.slice(1))) ten = d.slice(1);
  if (ten) return `+91 ${ten.slice(0, 5)} ${ten.slice(5)}`;
  return s.startsWith('+') ? s : `+${d}`;   // other countries: keep the digits, add the +
}

// "Dr. Ananya Mehra" → "Ananya" (for greetings)
export function greetName(name) {
  const words = String(name || '').trim().split(/\s+/).filter(Boolean);
  const titles = /^(dr|mr|mrs|ms|miss|prof|sir|smt|shri|sri|er|adv|ca)\.?$/i;
  const first = words.find(w => !titles.test(w));
  return first || words[0] || '';
}
